'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = SubFooter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modules = require('shared/modules');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import { Link } from 'react-router';

var CLASS_NAME = 'subfooter';
//import { KeepInMind } from 'shared/components/KeepInMind';
function SubFooter(_ref) {
  var modules = _ref.modules,
      route = _ref.route;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      modules.map(function (module, key) {
        return _react2.default.createElement(_modules.Module, (0, _extends3.default)({
          key: key,
          route: route
        }, module));
      })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SubFooter/SubFooter.jsx
// module id = 1132
// module chunks = 0